// Mapping des codes postaux vers les communes
export const COMMUNE_MAP = {
  "1188": "Gimel",
  "1195": "Bursinel",
  "1196": "Gland",
  "1197": "Prangins",
  "1209": "Petit-Saconnex",
  "1217": "Meyrin",
  "1218": "Grand-Saconnex",
  "1239": "Collex-Bossy",
  "1260": "Nyon",
  "1279": "Chavannes-de-Bogis",
  "1290": "Versoix",
  "1291": "Commugny",
  "1292": "Chambésy / Pregny",
  "1293": "Bellevue",
  "1294": "Genthod",
  "1295": "Mies",
  "1296": "Coppet",
  "1297": "Founex",
  "1298": "Céligny",
  "1299": "Crans-Près-Céligny",
};

// Fonction pour extraire la commune depuis l'adresse
export const getCommuneFromAddress = (address, postalCode) => {
  if (!address && !postalCode) return "Versoix";
  
  // Vérifier d'abord le code postal direct
  if (postalCode) {
    const cp = String(postalCode).trim();
    if (COMMUNE_MAP[cp]) return COMMUNE_MAP[cp];
  }
  
  if (!address) return "Versoix";
  
  const addressLower = address.toLowerCase();
  
  // Vérifier d'abord les noms de communes spécifiques (avant le code postal)
  if (addressLower.includes("nyon")) return "Nyon";
  if (addressLower.includes("bursinel")) return "Bursinel";
  if (addressLower.includes("gimel")) return "Gimel";
  if (addressLower.includes("crans-près-céligny") || addressLower.includes("crans-pres-celigny") || addressLower.includes("crans près céligny")) return "Crans-Près-Céligny";
  if (addressLower.includes("gland")) return "Gland";
  if (addressLower.includes("prangins")) return "Prangins";
  if (addressLower.includes("petit-saconnex")) return "Petit-Saconnex";
  if (addressLower.includes("meyrin")) return "Meyrin";
  if (addressLower.includes("grand-saconnex") || addressLower.includes("le grand-saconnex")) return "Grand-Saconnex";
  if (addressLower.includes("chavannes-des-bois")) return "Chavannes-des-Bois";
  if (addressLower.includes("chavannes-de-bogis") || addressLower.includes("bogis-bossey")) return "Chavannes-de-Bogis";
  if (addressLower.includes("tannay")) return "Tannay";
  
  // Chercher le code postal
  const match = address.match(/\b(1195|1239|1260|1279|1299|12\d{2})\b/);
  if (match) {
    const cp = match[1];
    // Cas spécial pour 1295 - vérifier si c'est Mies ou Tannay
    if (cp === "1295") {
      if (addressLower.includes("tannay")) return "Tannay";
      return "Mies";
    }
    return COMMUNE_MAP[cp] || "Versoix";
  }
  
  // Sinon chercher le nom de la commune
  if (addressLower.includes("collex-bossy")) return "Collex-Bossy";
  if (addressLower.includes("commugny")) return "Commugny";
  if (addressLower.includes("chambésy") || addressLower.includes("chambesy")) return "Chambésy / Pregny";
  if (addressLower.includes("pregny")) return "Chambésy / Pregny";
  if (addressLower.includes("bellevue")) return "Bellevue";
  if (addressLower.includes("genthod")) return "Genthod";
  if (addressLower.includes("mies")) return "Mies";
  if (addressLower.includes("coppet")) return "Coppet";
  if (addressLower.includes("founex")) return "Founex";
  if (addressLower.includes("céligny") || addressLower.includes("celigny")) return "Céligny";
  if (addressLower.includes("versoix")) return "Versoix";
  
  // Par défaut Versoix
  return "Versoix";
};

// Fonction pour obtenir la commune d'un restaurant
export const getCommune = (restaurant) => {
  // Priorité au champ commune en base de données
  if (restaurant.commune) return restaurant.commune;
  // Fallback sur la détection automatique
  return getCommuneFromAddress(restaurant.address, restaurant.postal_code);
};

// Fonction pour obtenir la région d'un restaurant (pour le filtre "Par lieu")
export const getRegion = (restaurant) => {
  if (restaurant.region) return restaurant.region;
  return getCommune(restaurant);
};
